import React from 'react';
import Icon from 'components/atoms/Icon/Icon';
import { EIconTypes } from 'constants/Icons';
import { colors } from 'theme/colors';
import { Grid, Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { StyledPhoto } from './styles';

const EmptyPhotoContainer = () => {
  const { t } = useTranslations();
  return (
    <StyledPhoto>
      <Grid sx={{ justifyContent: "center", alignContent: "flex-end" }}>
        <div id="icon-container">
          <Icon type={EIconTypes.user} color={colors.gray200} fontSize={42} />
        </div>
      </Grid>
      <Grid sx={{ gap: 0.5 }}>
        <Typography variant="subtitle2" style={{ color: colors.gray900, fontStyle: 'italic' }}>
          {`${t('general.legalEntityPhoto.text')}*`}
        </Typography>
        <Typography variant="body2" style={{ color: colors.gray400, fontStyle: 'italic' }}>
          {t('general.pleaseAddPhoto.text')}
        </Typography>
      </Grid>
    </StyledPhoto>
  );
};

export { EmptyPhotoContainer };
